<template>
  <div>
    <div class="loader__wrapper">
      <UiLoader
        :radius="10"
        color="var(--var-blue-100)"
        :circle-width="2"
      />
    </div>
    <img
      v-for="(image, index) in items"
      @click="fullSizeHandler(image)"
      :id="image"
      :key="image"
      :src="image"
      :ref="imageRef(index)"
      :class="imageClass(index)"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    items: any;
    isDragging: boolean;
  }>(),
  {
    items: [],
  },
);

const emit = defineEmits<{
  (e: 'full-screen', value: boolean): void;
}>();

const isOpenFullScreenModal = ref<boolean>(false);

const fullSizeHandler = (image: string) => {
  if (!props.isDragging) {
    isOpenFullScreenModal.value = true;
    emit('full-screen', isOpenFullScreenModal.value);
  }
};

const imageRef = (index: number) => {
  return index === 0 ? 'videoFirstRef' : undefined;
};

const imageClass = (index: number) => {
  return {
    'gallery-video-loop_first': index === 0,
    'gallery-video-loop': true,
  };
};
</script>

<style lang="scss" scoped>
.loader__wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: -1;
}

img {
  height: 450px;
  width: calc(100% / 1);
  object-fit: cover;
  margin-left: $m-3;
  border-radius: $br-3;

  &:first-child {
    margin-left: 0px;
  }

  @media (max-width: $lg) {
    width: calc(100% / 1);
  }
  @media (max-width: $md) {
    width: 100%;
    height: 100%;
  }
}

.gallery-video-loop {
  margin-left: 14px;
  &_first {
    margin-left: 0px;
  }

  @media (max-width: $lg) {
    margin-left: 10px;
    &_first {
      margin-left: 0px;
    }
  }
}
</style>
